import { useQuery } from '@tanstack/react-query';

const useDonations = () => {
  const endpoint = import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_GET_DONATIONS;

  return useQuery({
    queryKey: ['donations'],
    queryFn: async () => {
      const response = await fetch(endpoint);

      if (!response.ok) {
        throw new Error('Failed to fetch donations');
      }

      return response.json();
    },
    enabled: Boolean(endpoint),
    staleTime: 1000 * 60 * 10, // 10 minutes
    refetchInterval: 1000 * 60 * 10, // 10 minutes
  });
};

export default useDonations;
